import styled from 'styled-components';

export const StyledSpeechDropdown = styled.div`
  background: ${props => props.theme.themeColors.settingsDropdown.background};
  border-radius: 4px;
  border: 0.5px solid
    ${props => props.theme.themeColors.settingsDropdown.borderColor};
  box-shadow: ${props => props.theme.themeColors.settingsDropdown.boxShadow};
  display: flex;
  flex-direction: column;
  height: auto;
  opacity: ${props => (props.isOpened ? '1' : '0')};
  position: fixed;
  right: 32px;
  top: 72px;
  transition: visibility 0.3s, opacity 0.3s ease;
  visibility: ${props => (props.isOpened ? 'visible' : 'hidden')};
  width: 300px;
  z-index: 2000;

  @media(max-width: 575px) {
    left: 50%;
    right: unset;
    transform: translateX(-50%);
  }
`;

export const StyledSpeechSettingsWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 20px 24px;

  > span {
    color: ${props => props.theme.themeColors.settingsDropdown.textColor};
    font-size: 14.22px;
  }
`;

export const StyledFeedbackLinkWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 24px 24px 20px 24px;

  > a {
    color: ${props => props.theme.themeColors.settingsDropdown.textColor};
    font-size: 14.22px;
    text-decoration: none;
  }
`;

export const StyledPlaybackControlButtonsWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 20px 24px;
  gap: 24px;
`;


export const SpeechSpeedButton = styled.button`
  color: ${props =>
    props.active ? `${props.theme.genericColors.orangeSoft}` : `${props.theme.themeColors.settingsDropdown.textColor}`};
  cursor: pointer;
  height: 30px;
  padding: 0;
  width: auto;
  border: none;
  background: none;
  font-size: 14.22px;

  &:not(:last-child) {
    margin-right: 12px;
  }
`;

export const SpeechSpeakerButton = styled.button`
  color: ${props =>
    props.active ? `${props.theme.genericColors.orangeSoft}` : `${props.theme.themeColors.settingsDropdown.textColor}`};
  cursor: pointer;
  height: 30px;
  padding: 0;
  width: auto;
  border: none;
  background: none;

  &:not(:last-child) {
    margin-right: 12px;
  }
`;

export const StyledPlayButton = styled.button`
  cursor: pointer;
  padding: 0;
  width: 42px;
  height: 42px;
  border: none;
  background: none;

  svg path {
    fill: ${props => props.theme.genericColors.orangeSoft}
  }
  &:hover {
    svg path {
      fill: ${props => props.theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon.colorOnEmptyAndHover}
    }
  }
`;

export const StyledPauseButton = styled.button`
  cursor: pointer;
  padding: 0;
  width: 42px;
  height: 42px;
  border: none;
  background: none;

  svg path {
    fill: ${props => props.theme.genericColors.orangeSoft}
  }
  &:hover {
    svg path {
      fill: ${props => props.theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon.colorOnEmptyAndHover}
    }
  }
`;

export const StyledBackwardStepButton = styled.button`
  cursor: pointer;
  height: 30px;
  padding: 0;
  width: 42px;
  border: none;
  background: none;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 19px;
    height: 30px;
  }

  svg path {
    fill: ${props => props.theme.genericColors.orangeSoft}
  }
  &:hover {
    svg path {
      fill: ${props => props.theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon.colorOnEmptyAndHover}
    }
  }
`;

export const StyledForwardStepButton = styled.button`
  cursor: pointer;
  height: 30px;
  padding: 0;
  width: 42px;
  border: none;
  background: none;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 19px;
    height: 30px;
  }

  svg path {
    fill: ${props => props.theme.genericColors.orangeSoft}
  }
  &:hover {
    svg path {
      fill: ${props => props.theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon.colorOnEmptyAndHover}
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
`;

export const StyledOldReaderWrapper = styled.div`
  align-items: center;
  display: flex;
  font-size: 14.22px;
  padding: 20px 0 20px 24px;

  > a {
    color: ${props =>
      props.theme.themeColors.settingsDropdown.oldReaderLinkColor};
    margin: 0;
    padding: 0;
    text-decoration: none;

    &:hover {
      color: ${props =>
        props.theme.themeColors.settingsDropdown.oldReaderLinkColorOnHover};
    }
  }
`;

export const StyledPageControlsWrapper = styled.div`
  border-top: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor};
  display: flex;
  height: 72px;
  width: 100%;
`;

export const StyledControlButton = styled.button`
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  margin: 0;
  padding: 0;
  width: 88px;
`;

export const StyledRotateButton = styled(StyledControlButton)`
  border-right: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor}; ;
`;

export const StyledAdjustByHeightButton = styled(StyledControlButton)`
  border-right: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor}; ;
`;

export const StyledAdjustByWidthButton = styled(StyledControlButton)`
  border-right: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor}; ;
`;

export const StyledFullscreenStartButton = styled(StyledControlButton)``;

export const StyledDivider = styled.hr`
  border: 0.5px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor};
  margin-bottom: 0;
  margin-top: 0;
  width: calc(100% - 48px);
  user-select: none;
`;

export const StyledToggleSinglePageModeWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 1.125em 1.5em;

  > span {
    color: ${props => props.theme.themeColors.settingsDropdown.textColor};
    font-size: 14.22px;
  }
`;

export const PageModeButton = styled.button.attrs({ type: 'button' })`
  align-items: center;
  appearance: none;
  background: ${props => props.theme.themeColors.settingsDropdown.background};
  border: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.pageModeTogglerBorder};
  cursor: pointer;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 36px;

  & rect {
    fill: ${props => props.active && props.theme.genericColors.orangeSoft};
  }

  &:hover {
    & rect {
      fill: ${props => props.theme.genericColors.orangePeachy};
    }
  }

  &:focus {
    outline: 2px solid ${props => props.theme.genericColors.blueSoft};
  }

  &:active {
    & rect {
      fill: ${props => props.theme.genericColors.orangeSoft};
    }
  }

  &:not(:last-child) {
    margin-right: 16px;
  }
`;
